import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom'
import { Box } from '@mui/material'
import packageJson from '../../package.json'
import RenderMessage from '../garvan-react/Components/ModalFeedback/RenderMessage'
import { useGetWhoAmI } from '../APIs/Hooks/UserHooks'
import RenderError from '../garvan-react/Components/ModalFeedback/RenderError'
import { useUserContext } from '../Contexts/UserConfig'

function RequiredAuth() {
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const redirect = searchParams.get('redirect')
  const { whoAmI } = useUserContext()
  const { isLoading: authing, error: authError } = useGetWhoAmI()

  if (!whoAmI?.token && redirect) {
    window.location.reload()
  }
  if (authing)
    return (
      <RenderMessage
        message={{
          message: '',
          subject: 'Authenticating...',
          severity: 'info',
          loading: true,
        }}
      />
    )
  if (authError) {
    return <RenderError error={authError} />
  }
  if (whoAmI?.token) {
    if (redirect) {
      navigate(redirect, { replace: true })
    }
    return (
      <Box sx={{ width: 1, display: 'flex', justifyContent: 'center' }}>
        <Box
          aria-label={'Screen Too Small'}
          sx={{
            p: 2,
            display: { xs: 'flex', md: 'none' },
            width: 1,
            justifyContent: 'center',
          }}
        >
          <RenderMessage
            message={{
              message: `${packageJson.shortName} is designed for iPads and larger screens`,
              subject: 'This screen is too small!',
              severity: 'warning',
              loading: false,
            }}
            subjectFontSize={16}
          />
        </Box>
        <Box
          aria-label={'Authed Outlet'}
          sx={{
            display: { xs: 'none', md: 'flex' },
            width: 1,
            justifyContent: 'center',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    )
  } else {
    return (
      <Navigate
        to={
          '/' +
          (location.pathname.length > 1 ?
            `?redirect=${location.pathname + location.search}`
          : '')
        }
      />
    )
  }
}

export default RequiredAuth
